var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6665 3.66699C5.6665 4.77156 4.77107 5.66699 3.6665 5.66699C2.56193 5.66699 1.6665 4.77156 1.6665 3.66699C1.6665 2.56242 2.56193 1.66699 3.6665 1.66699C4.77107 1.66699 5.6665 2.56242 5.6665 3.66699Z",
    stroke: "#8F9EA3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 10.3337C12.3332 11.4382 11.4377 12.3337 10.3332 12.3337C9.2286 12.3337 8.33317 11.4382 8.33317 10.3337C8.33317 9.22909 9.2286 8.33366 10.3332 8.33366C11.4377 8.33366 12.3332 9.22909 12.3332 10.3337Z",
    stroke: "#8F9EA3",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33317 3.00033C8.33317 2.26395 8.93012 1.66699 9.6665 1.66699H10.9998C11.7362 1.66699 12.3332 2.26395 12.3332 3.00033V4.33366C12.3332 5.07004 11.7362 5.66699 10.9998 5.66699H9.6665C8.93012 5.66699 8.33317 5.07004 8.33317 4.33366V3.00033Z",
    stroke: "#8F9EA3",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 9.66699C1.6665 8.93061 2.26346 8.33366 2.99984 8.33366H4.33317C5.06955 8.33366 5.6665 8.93061 5.6665 9.66699V11.0003C5.6665 11.7367 5.06955 12.3337 4.33317 12.3337H2.99984C2.26346 12.3337 1.6665 11.7367 1.6665 11.0003V9.66699Z",
    stroke: "#8F9EA3",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeButton);
export default __webpack_public_path__ + "static/media/typeButton.9cabd0b1335958d4fa728c696e3b5076.svg";
export { ForwardRef as ReactComponent };